import { Autocomplete, Grid, TextField } from "@mui/material";
import { usePhoneNumber } from "./hooks";
import { dialCodes } from "../../../utility";
import { useAppSelector } from "../../../redux";
import { selectText } from "../../LanguageSelect/LanguageSelectSlice";
import { AcctionButtons } from "../AcctionButtons";

interface PhoneModalProps {
  handleClose(): void;
}

export function PhoneModal(props: PhoneModalProps) {
  const { handleClose } = props;
  const text = useAppSelector(selectText);

  const { phone, dialCode, handleAreaCodeChange, handlePhoneChange, updatePhone } = usePhoneNumber({
    handleClose,
  });

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xl={12} xs={12}>
          <Autocomplete
            fullWidth
            id="countries"
            options={dialCodes}
            getOptionLabel={(dialCode) => dialCode.name}
            onChange={handleAreaCodeChange}
            renderInput={(params) => <TextField {...params} label={text.formsFeilds.country} />}
            filterOptions={(options, state) => {
              const inputValue = state.inputValue.toLowerCase();
              return options.filter((option) => option.name.toLowerCase().startsWith(inputValue));
            }}
          />
        </Grid>
        <Grid item xl={3} xs={12} sm={12}>
          <TextField
            fullWidth
            required
            label={text.conutryCode}
            name="country_code"
            id="country_code"
            size="medium"
            value={dialCode}
            disabled
          />
        </Grid>
        <Grid item xl={9} xs={12} sm={12}>
          <TextField
            fullWidth
            required
            label={text.formsFeilds.phone}
            name="phone"
            id="phone_field"
            size="medium"
            value={phone ? phone : ""}
            onChange={handlePhoneChange}
            disabled={!dialCode}
            type="phone"
          />
        </Grid>

        <Grid item xl={9} xs={12} sm={12}>
          <AcctionButtons type="button" action={updatePhone} handleClose={handleClose} title={text.update} />
        </Grid>
      </Grid>
    </>
  );
}
